import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordGeneralInformationModel} from '../../../api/model/medicalRecordGeneralInformation.model';

@Injectable({providedIn: 'root'})
export class MedicalRecordGeneralInformationRepository extends AbstractRepositoryV2<MedicalRecordGeneralInformationModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalRecordGeneralInformation', serviceElementsFactory, injector);
    }
}
